<script setup lang="ts">
/** The last frame: the victory painting as a banner with the call in outlined lettering and the PLAY FREE plate over it. */
import { useI18n } from '@/i18n';
import GameIcon from '@/ui/kit/GameIcon.vue';
import ActionButton from '@/ui/panel/ActionButton.vue';
import { sceneArt } from '@/ui/panel/art-path';

defineEmits<{ play: [] }>();
const { t } = useI18n();
</script>

<template>
  <section class="final" data-section="final" data-parallax aria-labelledby="final-title">
    <div class="k-girder rim" aria-hidden="true"></div>
    <img class="scene" :src="sceneArt('victory')" alt="" width="1600" height="686" loading="lazy" decoding="async" />
    <div class="veil" aria-hidden="true"></div>
    <div class="copy" data-slam>
      <h2 id="final-title" class="k-title call">{{ t('landing.final.tagline') }}</h2>
      <ActionButton variant="primary" size="lg" cta class="go" @click="$emit('play')">
        <GameIcon name="trophy" :size="48" />
        {{ t('landing.final.play') }}
      </ActionButton>
    </div>
  </section>
</template>

<style scoped>
.final {
  position: relative;
  isolation: isolate;
  display: grid;
  place-items: center;
  min-height: clamp(360px, 62dvh, 600px);
  overflow: clip;
  background: #0a1119;
}

.rim {
  position: absolute;
  inset: 0 0 auto 0;
  z-index: 1;
}

.scene {
  position: absolute;
  inset: -6% 0;
  z-index: -2;
  width: 100%;
  height: 112%;
  object-fit: cover;
  transform: translateY(calc(var(--py, 0) * -5%));
}

.veil {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: radial-gradient(ellipse at center, rgba(8, 14, 21, 0.1), rgba(8, 14, 21, 0.72));
}

.copy {
  display: grid;
  justify-items: center;
  gap: clamp(16px, 3vw, 30px);
  padding: 56px 16px;
  text-align: center;
}

.call {
  font-size: clamp(2.6rem, 1rem + 8vw, 6.4rem);
  text-transform: uppercase;
  filter: drop-shadow(0 8px 0 rgba(13, 20, 28, 0.5));
}

.go {
  --h: 4.6rem;
  padding-inline: 2.4rem 2.8rem;
}
</style>
